import { Seo } from '@/shared/seo/Seo'
import { Section, SectionHeader } from '@/shared/ui/Section'
import { Prose } from '@/shared/ui/Prose'
import { site } from '@/content/site'

/**
 * TODO: This policy must be reviewed against what the site actually does
 * before launch — a generated policy that misdescribes real data handling is
 * worse than none (SPEC.md §13). It currently describes the implemented
 * behaviour: a contact form posting to our own Worker, and no cookies.
 */
export function Component() {
  const hasEmail = !site.contact.email.startsWith('TODO')

  return (
    <>
      <Seo
        title="Privacy policy"
        description="How Softife collects, uses, and stores personal information submitted through this website."
        path="/privacy"
      />

      <Section size="lg">
        <SectionHeader as="h1" title="Privacy policy" />
        <Prose className="mt-8">
          <p>
            <strong>TODO: legal review required before launch.</strong> This document describes the
            site as implemented. It must be checked against the final analytics, email, and hosting
            arrangements, and against the regulations that apply to Softife's jurisdiction.
          </p>

          <h2>What we collect</h2>
          <p>
            When you submit the contact form we collect the name, email address, company, project
            type, budget range, and message you provide. We do not collect anything else through
            this website, and we do not use advertising or tracking cookies.
          </p>

          <h2>Why we collect it</h2>
          <p>
            Solely to respond to your enquiry and to discuss potential work. We do not sell personal
            information, and we do not add you to a marketing list without your explicit request.
          </p>

          <h2>Who processes it</h2>
          <ul>
            <li>Our website and contact endpoint are hosted on Cloudflare.</li>
            <li>Form submissions are delivered by email through a transactional email provider.</li>
            <li>
              Spam protection is provided by Cloudflare Turnstile, which processes technical signals
              about the submission but not the content of your message.
            </li>
          </ul>

          <h2>How long we keep it</h2>
          <p>
            TODO: state the actual retention period for enquiry emails and confirm it matches how
            the inbox is managed in practice.
          </p>

          <h2>Your rights</h2>
          <p>
            You can ask us what information we hold about you, ask us to correct it, or ask us to
            delete it.{' '}
            {hasEmail ? (
              <>
                Contact us at <a href={`mailto:${site.contact.email}`}>{site.contact.email}</a> and
                we will respond.
              </>
            ) : (
              'TODO: add the contact route for data requests.'
            )}
          </p>

          <h2>Changes</h2>
          <p>If we change how this site handles personal information, we will update this page.</p>
        </Prose>
      </Section>
    </>
  )
}

Component.displayName = 'PrivacyPage'
